import { Menu, MenuContent, MenuItem, MenuSeparator, MenuTrigger } from '@patchbay/ui'
import { useNavigate, useRouterState } from '@tanstack/react-router'
import { BookOpen, CircleHelp, Keyboard, LifeBuoy } from 'lucide-react'
import { helpForPathname } from '../../lib/help/links'

/**
 * The top bar's ? menu (docs/help-centre.md): help for the page you are on, the Help centre, and the key sheet.
 * Owner: slice 36 `web-help-centre`; slice 14 `web-shell` mounts it in the TopBar's `right` slot and passes
 * `onKeySheet` (the key sheet's open state is the shell's).
 */
export function HelpMenu({ onKeySheet }: { onKeySheet?: () => void }) {
  const navigate = useNavigate()
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  const here = helpForPathname(pathname)
  return (
    <Menu>
      <MenuTrigger
        aria-label="Help"
        data-slot="shell-icon"
        className="inline-flex size-8 cursor-pointer items-center justify-center rounded-md text-muted-foreground hover:bg-muted"
      >
        <CircleHelp className="size-4" />
      </MenuTrigger>
      <MenuContent>
        {here ? (
          <MenuItem onClick={() => navigate({ href: here })}>
            <LifeBuoy /> Help for this page
          </MenuItem>
        ) : null}
        <MenuItem onClick={() => navigate({ to: '/help' })}>
          <BookOpen /> Help centre
        </MenuItem>
        {onKeySheet ? (
          <>
            <MenuSeparator />
            <MenuItem onClick={onKeySheet} keys="?">
              <Keyboard /> Keyboard shortcuts
            </MenuItem>
          </>
        ) : null}
      </MenuContent>
    </Menu>
  )
}
